export default __webpack_public_path__ + "static/media/logo_blue.f4f466c1.png";